const UID_KEY = "smrt_uid";
const TIER_KEY = "smrt_tier";

export function setIdentity({ uid, tier }) {
  if (typeof window === "undefined") return; // SSR guard
  try {
    localStorage.setItem(UID_KEY, String(uid));
    localStorage.setItem(TIER_KEY, String(tier));
  } catch {
    // Ignore storage availability or quota errors
  }
}

export function getIdentity() {
  if (typeof window === "undefined") return null; // SSR guard
  try {
    const uid = localStorage.getItem(UID_KEY);
    return uid ? { uid, tier: localStorage.getItem(TIER_KEY) } : null;
  } catch {
    return null; // Ignore storage availability errors
  }
}

export function clearIdentity() {
  if (typeof window === "undefined") return; // SSR guard
  try {
    localStorage.removeItem(UID_KEY);
    localStorage.removeItem(TIER_KEY);
  } catch {
    // Ignore storage availability errors
  }
}
